import { useParams } from 'react-router-dom';

import { useMyPermissions } from '@/api/getMyPermissions';
import { hasGrantOnScope } from '@/models/permission';

/**
 * A predicate telling whether the signed-in user holds any Grant on a Sandbox of
 * the current Game — used per row, hence a predicate and not a hook call
 * (`usePermissionCheck` cannot be called inside a map).
 *
 * Fails closed: false while the Grants are loading and on error.
 */
export const useCanEnterSandbox = () => {
  const { studioCode, gameCode } = useParams<{
    studioCode?: string;
    gameCode?: string;
  }>();
  const { data } = useMyPermissions();

  return (sandboxCode: string) =>
    data?.roles
      ? hasGrantOnScope(data.roles, gameCode, sandboxCode, studioCode)
      : false;
};
